import Immerable from '@naruto/naruto-models/src/types/GeneralImmer';
import { LocalStorageOptions } from './types';

class LocalStorageOperator<SaveValue = unknown> extends Immerable {
  public storageOption: LocalStorageOptions;

  constructor(storageOptions?: LocalStorageOptions) {
    super();
    this.storageOption = !storageOptions
      ? {
          savedStorageItemName: ''
        }
      : storageOptions;
  }

  setStorageOption(storageOptions: LocalStorageOptions): void {
    this.storageOption = storageOptions;
  }

  deleteStorage(): void {
    const localStorageTarget = localStorage.getItem(this.storageOption.savedStorageItemName);
    if (localStorageTarget) {
      localStorage.removeItem(this.storageOption.savedStorageItemName);
    }
  }

  updateStorage(value: SaveValue): void {
    const localStorageTarget = localStorage.getItem(this.storageOption.savedStorageItemName);
    if (localStorageTarget) {
      this.deleteStorage();
    }
    localStorage.setItem(this.storageOption.savedStorageItemName, JSON.stringify(value));
  }

  readStorage(): SaveValue | null {
    const localStorageTarget = localStorage.getItem(this.storageOption.savedStorageItemName);
    if (localStorageTarget) {
      try {
        const localStorageJson = JSON.parse(localStorageTarget);
        return localStorageJson as SaveValue;
      } catch (err) {
        throw new Error('parse local storage failed, please make sure saved structure is valid object');
      }
    }
    return null;
  }
}

export default LocalStorageOperator;
